import styled from "styled-components";

export const LottieContainer = styled.div<{ showWithTextLottie: boolean }>(({ showWithTextLottie }) => ({
    width: showWithTextLottie ? "98px" : "56px",
}));
